<article>
  <section class="hero-gradient-cc py-5">

    <div class="container py-md-5">
      <img alt="Adobe Express"
           ngSrc="assets/images/adobe/creative-cloud.svg"
           class="cc-logo"
           height="192"
           width="192"/>

      <div class="row">
        <h1 class="d-flex mt-4 mt-md-5 fw-bold display-6 align-items-center col-12 col-xl-8">
          Getting Started With Adobe Creative Cloud All Apps Pro
        </h1>

        <p class="mt-4 fs-5 fw-bold col-12 col-xl-8">
          Adobe Creative Cloud All Apps Pro is a comprehensive suite that gives
          you access to the entire range of Adobe Creative Cloud applications
          like Photoshop, Illustrator, Premiere Pro, InDesign, After Effects,
          and more. With cloud storage, seamless app integration, and regular
          updates, Adobe Creative Cloud All Apps Pro enables users to work
          efficiently across devices and bring their ideas to life with
          professional-grade tools and resources.
        </p>
      </div>

      <div>
        <a routerLink="/adobe/creative-cloud/request"
           class="btn btn-dark text-white mt-3 mb-5 px-5 py-3 text-uppercase"
           id="cc-landing-request-access-button">
          Request Adobe CC All Apps Pro License
        </a>
      </div>

    </div>
  </section>

  <app-adobe-cc-apps />

  <app-adobe-cc-info-instructions
     [isLicenseActive]="isLicenseActive()"/>

  <app-adobe-shared-creative-campus-blurb />

  <app-adobe-shared-aup />

</article>
